import http from '@/http'
const URL = '/admin/settings/wa/templates'

export const getPositus = async (params) => {
  const list = (await http.get(URL + '/positus-templates', { params: params }))
  return list
}

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveTemplate = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}
export const deleteTemplate = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export default {
  getPositus,
  list,
  show,
  saveTemplate,
  deleteTemplate,
  changeStatus
}
